import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Facebook as FacebookIcon } from '../Icons';
import SocialIcon from "Components/Icons/SocialIcon";

export default class IntegrationSelect extends React.Component
{
    static propTypes = {
        integrations: PropTypes.object.isRequired,
        onSelect: PropTypes.func.isRequired,

        selected: PropTypes.object,
    };

    static defaultProps = {
        selected: {}
    };

    render()
    {
        return _.map(this.props.integrations, integration => {
            const className = classNames({
                "flex p-4 bg-white rounded border select-none cursor-pointer": true,
                "border-blue-600 bg-blue-100": Boolean(this.props.selected[integration.id])
            });

            return <div key={integration.id} className={className} onClick={() => this.props.onSelect(integration.id)}>
                <div className='flex-1'>
                    <strong>{integration.name}</strong>
                    <p>{integration.about}</p>
                </div>
                <SocialIcon type={integration.type} className='flex-strink-0 w-4 h-4' />
            </div>
        });
    }
}
